type EncounterTimestamps = {
  started_at?: string | null;
  created_at: string;
};

// The moment a recording is shown under: when it started, or when the
// encounter was created for recordings that never reported a start time.
// The server sorts by started_at only and lists rows without it last, see
// sortConsultationsByDate.
export const getEncounterDate = (encounter: EncounterTimestamps): Date =>
  new Date(encounter.started_at ?? encounter.created_at);
